module.exports = __webpack_public_path__ + "media/images/icons/ic-recommend-ed9036654cb62a929ada1c520e6cb70f.svg";